import { render } from "./Terpene.vue?vue&type=template&id=121cdaf4"
import script from "./Terpene.vue?vue&type=script&lang=js"
export * from "./Terpene.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__